import { render, staticRenderFns } from "./InputCoaWithoutChild.vue?vue&type=template&id=ee9e3162"
import script from "./InputCoaWithoutChild.vue?vue&type=script&lang=js"
export * from "./InputCoaWithoutChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports